
































import Vue, { PropType } from "vue";
import BasicInformationEdit from "@/stores/pages/components/BasicInformationEdit.vue";
import EditClickAndCollect from "@/stores/pages/components/EditClickAndCollect.vue";
import PaymentConfigurationEdit from "@/stores/pages/components/PaymentConfigurationEdit.vue";
import PosConfigurationEdit from "@/stores/pages/components/PosConfigurationEdit.vue";
import { storeService } from "@/common/services/StoreService";
import { CreateAdminStoreData } from "@/stores/pages/models/CreateAdminStoreData";
import { AdminStore } from "@/common/models/AdminStore";
import { StoreEditorPage } from "@/stores/pages/enums/StoreEditorPage";

export default Vue.extend({
  name: "StoreEditor",
  components: {
    BasicInformationEdit,
    EditClickAndCollect,
    PaymentConfigurationEdit,
    PosConfigurationEdit,
  },
  props: {
    store: {
      type: Object as PropType<AdminStore>,
      required: true,
    },
    page: {
      type: Number as () => StoreEditorPage,
      required: true,
    },
  },
  data() {
    return {
      StoreEditorPage: StoreEditorPage,
      isFormValid: true,
      savingStore: false,
      createStoreData: CreateAdminStoreData.fromAdminStore(this.store),
      clickAndCollectConfiguration: this.store.configuration?.clickAndCollectConfiguration,
      calendarConfiguration: this.store.configuration?.calendarConfiguration,
    };
  },
  watch: {
    store: function (store: AdminStore): void {
      this.clickAndCollectConfiguration = store.configuration?.clickAndCollectConfiguration;
      this.calendarConfiguration = store.configuration?.calendarConfiguration;
    },
  },
  methods: {
    isDataValid(): boolean {
      switch (this.page) {
        case StoreEditorPage.BASIC_INFO:
          return this.createStoreData.isBasicInfoValid();
        case StoreEditorPage.ORDERING_OPTIONS:
          return this.createStoreData.isCalendarConfigurationValid();
        case StoreEditorPage.PAYMENT_CONFIGURATION:
          return this.createStoreData.isPaymentConfigurationValid();
        case StoreEditorPage.POS_CONFIGURATION:
          return this.createStoreData.isPosConfigurationValid();
      }
    },
    async saveStore(): Promise<void> {
      this.savingStore = true;
      const toSave = JSON.parse(JSON.stringify(this.store));
      const updatedData = JSON.parse(JSON.stringify(this.createStoreData));
      switch (this.page) {
        case StoreEditorPage.BASIC_INFO:
          toSave.code = updatedData.code;
          toSave.name = updatedData.name;
          toSave.address = updatedData.address;
          toSave.email = updatedData.email;
          toSave.telephone = updatedData.telephone;
          toSave.location.latitude = updatedData.location.latitude;
          toSave.location.longitude = updatedData.location.longitude;
          toSave.timeZone = updatedData.timeZone;
          toSave.vatNumber = updatedData.vatNumber;
          toSave.active = updatedData.active;
          break;
        case StoreEditorPage.ORDERING_OPTIONS:
          toSave.configuration.clickAndCollectConfiguration = updatedData.configuration.clickAndCollectConfiguration;
          if (toSave.configuration.clickAndCollectConfiguration.enableClickAndCollect) {
            toSave.configuration.calendarConfiguration = updatedData.configuration.calendarConfiguration;
          } else {
            toSave.configuration.calendarConfiguration = null;
          }
          break;
        case StoreEditorPage.PAYMENT_CONFIGURATION:
          toSave.configuration.paymentConfiguration = updatedData.configuration.paymentConfiguration;
          break;
        case StoreEditorPage.POS_CONFIGURATION:
          toSave.configuration.posConfiguration = updatedData.configuration.posConfiguration;
          break;
      }
      try {
        await storeService.updateStore(toSave);
        this.$emit("updated");
      } catch (e) {
        this.savingStore = false;
      }
    },
    onClose(): void {
      this.savingStore = false;
      this.$emit("close");
    },
  },
});
